import { Routes, Route, Navigate } from 'react-router-dom'
import BotsList from '@/pages/Bots/BotsList'
import BotDetails from '@/pages/Bots/BotDetails'
import BotAutoResources from '@/pages/Bots/BotAutoResources'
import BotTimeout from '@/pages/Bots/BotTimeout'
import BotStatistics from '@/pages/Bots/BotStatistics'
import BotIntegration from '@/pages/Bots/BotIntegration'
import BotCustomBlock from '@/pages/Bots/BotCustomBlock'
import BotAccessManagement from '@/pages/Bots/BotAccessManagement'
import BotAccessAdd from '@/pages/Bots/BotAccessAdd'
import BotWhitelist from '@/pages/Bots/BotWhitelist'
import BotWhitelistAdd from '@/pages/Bots/BotWhitelistAdd'
import TrafficList from '@/pages/Traffic/TrafficList'
import AddResource from '@/pages/Traffic/AddResource'
import ResourceDetails from '@/pages/Traffic/ResourceDetails'
import ResourcePrice from '@/pages/Traffic/ResourcePrice'
import ResourceLimit from '@/pages/Traffic/ResourceLimit'
import ResourcePriority from '@/pages/Traffic/ResourcePriority'
import ResourceFilters from '@/pages/Traffic/ResourceFilters'
import ResourceGeo from '@/pages/Traffic/ResourceGeo'
import ResourceCategories from '@/pages/Traffic/ResourceCategories'
import ResourceMode from '@/pages/Traffic/ResourceMode'
import ResourceToken from '@/pages/Traffic/ResourceToken'
import ResourceLink from '@/pages/Traffic/ResourceLink'
import ResourceStatistics from '@/pages/Traffic/ResourceStatistics'
import ResourceWhitelist from '@/pages/Traffic/ResourceWhitelist'
import ResourceWhitelistAdd from '@/pages/Traffic/ResourceWhitelistAdd'
import ResourcesList from '@/pages/Resources/ResourcesList'
import Shows from '@/pages/Shows'
import ShowStatistics from '@/pages/ShowStatistics'
import Statistics from '@/pages/Statistics'
import Profile from '@/pages/Profile'
import Layout from '@/components/layout/Layout'

export function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<BotsList />} />
        <Route path="bots/:botId" element={<BotDetails />} />
        <Route path="bots/:botId/auto-resources" element={<BotAutoResources />} />
        <Route path="bots/:botId/timeout" element={<BotTimeout />} />
        <Route path="bots/:botId/statistics" element={<BotStatistics />} />
        <Route path="bots/:botId/integration" element={<BotIntegration />} />
        <Route path="bots/:botId/custom-block" element={<BotCustomBlock />} />
        <Route path="bots/:botId/access" element={<BotAccessManagement />} />
        <Route path="bots/:botId/access/add" element={<BotAccessAdd />} />
        <Route path="bots/:botId/whitelist" element={<BotWhitelist />} />
        <Route path="bots/:botId/whitelist/add" element={<BotWhitelistAdd />} />
        <Route path="traffic" element={<TrafficList />} />
        <Route path="traffic/add" element={<AddResource />} />
        <Route path="traffic/:resourceId" element={<ResourceDetails />} />
        <Route path="traffic/:resourceId/price" element={<ResourcePrice />} />
        <Route path="traffic/:resourceId/limit" element={<ResourceLimit />} />
        <Route path="traffic/:resourceId/priority" element={<ResourcePriority />} />
        <Route path="traffic/:resourceId/filters" element={<ResourceFilters />} />
        <Route path="traffic/:resourceId/geo" element={<ResourceGeo />} />
        <Route path="traffic/:resourceId/categories" element={<ResourceCategories />} />
        <Route path="traffic/:resourceId/mode" element={<ResourceMode />} />
        <Route path="traffic/:resourceId/token" element={<ResourceToken />} />
        <Route path="traffic/:resourceId/link" element={<ResourceLink />} />
        <Route path="traffic/:resourceId/statistics" element={<ResourceStatistics />} />
        <Route path="traffic/:resourceId/whitelist" element={<ResourceWhitelist />} />
        <Route path="traffic/:resourceId/whitelist/add" element={<ResourceWhitelistAdd />} />
        <Route path="resources" element={<ResourcesList />} />
        <Route path="shows" element={<Shows />} />
        <Route path="shows/:showId/statistics" element={<ShowStatistics />} />
        <Route path="statistics" element={<Statistics />} />
        <Route path="profile" element={<Profile />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  )
}
